import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-role-permissions-form', {
  mixins: [eventListenerMixin],

  properties: {
    defaultPermissions: {
      type: Object,
      default: {},
    },
  },

  connected() {
    this.listenTo(this.querySelector('.permissions-groups'), {
      'tr-checkbox-field:change': this.handleCheckboxChange.bind(this),
    });
  },

  disconnected() {
    this.stopListening();
  },

  selectDefaultPermissions() {
    const selectedPermissions = Object.keys(this.defaultPermissions)
      .filter(key => this.defaultPermissions[key]);

    [...this.querySelectorAll('.permissions')].forEach((wrapper) => {
      [...wrapper.querySelectorAll('tr-checkbox-field')].forEach((checkbox) => {
        const inputName = checkbox.querySelector('.mdc-checkbox__native-control').name;
        // eslint-disable-next-line no-param-reassign
        checkbox.checked = selectedPermissions.some(p => inputName.endsWith(p));
      });

      this.selectGroupCheckbox(wrapper);
    });
  },

  showSavedMessage(message) {
    const restoreButton = this.querySelector('.restore-button');
    const savedMessage = this.querySelector('.saved-message');

    savedMessage.querySelector('.content').textContent = message;
    if (restoreButton) restoreButton.classList.add('hidden');
    savedMessage.classList.add('show');

    setTimeout(() => {
      savedMessage.classList.remove('show');
      if (restoreButton) restoreButton.classList.remove('hidden');
    }, 1000);
  },

  handleCheckboxChange(event) {
    const groupCheckbox = closest(event.target, '.group-checkbox');
    if (groupCheckbox) {
      this.togglePermissions(groupCheckbox.nextElementSibling, event.detail.checked);
      return;
    }

    this.selectGroupCheckbox(closest(event.target, '.permissions'));
  },

  togglePermissions(permissionsWrapper, checked) {
    [...permissionsWrapper.querySelectorAll('tr-checkbox-field')].forEach((checkbox) => {
      // eslint-disable-next-line no-param-reassign
      checkbox.checked = checked;
    });
  },

  selectGroupCheckbox(permissionsWrapper) {
    const groupCheckbox = permissionsWrapper.previousElementSibling;
    const checkboxes = [...permissionsWrapper.querySelectorAll('tr-checkbox-field')];

    if (checkboxes.filter(cb => cb.checked).length === 0) {
      groupCheckbox.checked = false;
      groupCheckbox.indeterminate = false;
    } else if (checkboxes.filter(cb => !cb.checked).length === 0) {
      groupCheckbox.checked = true;
      groupCheckbox.indeterminate = false;
    } else {
      groupCheckbox.checked = false;
      groupCheckbox.indeterminate = true;
    }
  },
});
